<i18n>
{
	"en": {
		"language": "Language",
		"transporter": "Transporter"
	},
	"no": {
		"language": "Språk",
		"transporter": "Transportør"
	}
}
</i18n>
<template>
	<div class="general–settings">
		<t-form-group :title="$t('language')">
			<t-select
				:items="languages"
				:selectedItem="settings.language"
				displayName="text"
				width="280px"
				@change="onSetlanguage"
			/>
		</t-form-group>
		<t-form-group :title="$t('transporter')">
			<t-select
				:items="companies"
				:selectedItem="settings.company"
				:selectedItems="[]"
				displayName="displayName"
				width="280px"
				@change="onSetCompany"
			/>
		</t-form-group>
	</div>
</template>

<script>
import {
	mapState, mapGetters, mapActions
} from './store/settings.store.js';
import {
	mapState as usersState, mapGetters as usersGetters, mapActions as usersActions
} from '@/modules/login/store/login.store.js';
export default {
	name: 'General',
	data() {
		return {
			settings: {
				language: null,
				company: {}
			}
		};
	},
	computed: {
		...usersState(['companies']),
		...usersGetters(['company',]),
		...mapState(['languages']),
		...mapGetters(['selectedLanguage']),
	},
	mounted() {
		this.settings.language = this.selectedLanguage;
		this.settings.company = this.company;
	},
	methods: {
		...mapActions(['saveGeneralSettings']),
		...usersActions(['setCompany',]),
		onSetlanguage(event) {
			this.settings.language = event;
		},
		onSetCompany(event) {
			this.settings.company = event;
		},
		processSave() {
			this.saveGeneralSettings(this.settings);

			if (this.company.id !== this.settings.company.id) {
				this.setCompany(this.settings.company.id);
				return true;
			}
			return false;
		},
		processCancel() {
			this.settings.company = this.company;
			this.settings.language = this.selectedLanguage;
		}
	}
};
</script>

<style lang="scss" scoped>
	.general–settings {
		display: grid;
		grid-template-columns: auto;
		row-gap: 20px;
	}
</style>
